import { Retry } from '@/assets/icons'

type RetryButtonProps = {
  onClick: () => void
}

/**
 * Retry Button Component
 *
 * Reusable button for retrying failed operations in the content viewer.
 * Provides consistent styling across all error states.
 */
export default function RetryButton({ onClick }: RetryButtonProps) {
  return (
    <button
      className="flex gap-x-2 items-center rounded-md bg-brand-500 border-[1px] border-brand-500 px-2 py-1 mb-4 text-sm font-semibold text-white shadow-sm hover:bg-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-400"
      onClick={onClick}
    >
      <div>Retry</div>
      <div className="w-5 h-5">
        <Retry />
      </div>
    </button>
  )
}
